import { EuiButtonIcon } from "@inscopix/ideas-eui";
import { captureException } from "@sentry/react";
import { ToolVersion } from "graphql/_Types";
import { useState } from "react";
import { addUtilityToastFailure } from "utils/addUtilityToastFailure";
import { downloadToolSpec } from "../api/downloadToolSpec";
import { DRS_FILE_ACTION_ICONS } from "types/Icons";
import { Tooltip } from "components/Tooltip/Tooltip";

export interface ButtonDownloadToolSpecProps {
  toolVersionId: ToolVersion["id"];
}

export const ButtonDownloadToolSpec = ({
  toolVersionId,
}: ButtonDownloadToolSpecProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const handleClick = async () => {
    setIsLoading(true);
    try {
      await downloadToolSpec(toolVersionId);
    } catch (err) {
      captureException(err);
      addUtilityToastFailure("Failed to download tool specification");
    }
    setIsLoading(false);
  };

  return (
    <Tooltip content="Download the currently configured parameter & output specification as JSON">
      <EuiButtonIcon
        iconType={DRS_FILE_ACTION_ICONS["download"]}
        isLoading={isLoading}
        onClick={() => void handleClick()}
      />
    </Tooltip>
  );
};
